module.exports = __webpack_public_path__ + "static/media/feederMonitor.9a9c9fd6.svg";